import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { profileKeys } from '@core/react-query/features/profile/profileKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetServerTime = (
  payload: RequestTypes['getServerTime'] = {},
  options?: UseQueryOptions<{ time: string }, RequestErrorType>,
) => {
  return useQuery({
    cacheTime: 0,
    ...profileKeys.getServerTime(payload),
    ...options,
  })
}
